import { Dropdown } from "@freightsimple/ui-core/Controls/Dropdown";
import { claimsFieldWidth } from "../Helpers/claimsFieldWidth";
import { FreightClaimItemCondition } from "@freightsimple/generated-dashboard-openapi-client/models/FreightClaimItemCondition";

function describeItemCondition(value: FreightClaimItemCondition): string {
  switch (value) {
    case FreightClaimItemCondition.New:
      return "New";
    case FreightClaimItemCondition.Used:
      return "Used";
  }
}

const conditionOptions = Object.values(FreightClaimItemCondition).map((v) => ({
  value: v,
  label: describeItemCondition(v),
}));

interface ItemConditionDropdownProps {
  itemCondition: FreightClaimItemCondition;
  setItemCondition: (_: FreightClaimItemCondition) => void;
}

export function ClaimsItemConditionDropdown(props: ItemConditionDropdownProps) {
  const { itemCondition, setItemCondition } = props;
  return (
    <Dropdown
      data-testid="item-condition-dropdown"
      value={itemCondition}
      onChange={(v) => setItemCondition(v as FreightClaimItemCondition)}
      options={conditionOptions}
      width={claimsFieldWidth.token}
    />
  );
}
